<template>
  <div class="bakgrund"></div>

  <h2 v-if="header">{{ header }}</h2>

  <List v-if="listItems && listItems.length" :listItems="listItems"></List>

  <Pagination
    v-if="items == 0 && listItems?.length && totalMatching > take"
    :totalMatching="totalMatching"
    :labels="texts"
    :pageSize="take"
    @changePage="getItems"
    />

  <div class="merlank" v-if="linkUrl && texts && items > 0">
    <a :href="linkUrl">{{ texts.linkText }}</a>
  </div>
</template>

<script>
import List from "./components/list.vue";
import artikellistservice from "../plugins/artikellistservice";
import Pagination from "../pagination/pagination.vue";

export default {
  name: "ArtikelListBlock",
  props: {
    baseApiUrl: String,
    visningssidaUrl: String,
    orgId: Array,
    nyckelord: Array,
    id: String,
    header: String,
    items: Number,
    linkUrl: String,
    texts: Object,
    visaSomPuffar: Boolean,
    visaListaMedBilder: Boolean,
    tvaspalt: Boolean,
    arrowToLeft: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: function () {
    return {
      take: 10,
      listItems: undefined,
      totalMatching: 0,
    };
  },
  components: {
    List,
    Pagination,
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $visaSomPuffar: this.visaSomPuffar,
      $visaListaMedBilder: this.visaListaMedBilder,
      $colsDesktop: this.tvaspalt ? "row-cols-md-2" : "row-cols-md-3",
      $texts: this.texts,
      $arrowToLeft: this.arrowToLeft,
    };

    this.take = this.items == 0 ? 10 : this.items;

    var urlParams = new URLSearchParams(window.location.search);
    var pageNr = urlParams.get("page") != null ? parseInt(urlParams.get("page")) : 1;
    
    this.getItems(pageNr);
  },
  methods: {
    getItems(pageNr) {
      let nrToSkip = (pageNr - 1) * this.take;
      artikellistservice
        .getItems(this.baseApiUrl, this.visningssidaUrl, this.orgId, this.take, nrToSkip, this.nyckelord)
        .then((result) => {
          if (result && result.status == 200) {
            this.listItems = result.data.listItems;
            this.totalMatching = result.data.totalMatching;
          }
        });
    },
  },
};
</script>
